




















































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { PolicyStatus } from 'admiral-core';
import PolicyStatusBadge from '@/components/common/PolicyStatusBadge.vue';
import PolicyStatusProgress from '@/views/pages/policies/PolicyStatusProgress.vue';
import {
  emptyPolicyResults,
  PolicyResults,
} from '@/utils/calculatePolicyResults';

@Component({
  name: 'policy-results-summary-card',
  components: {
    PolicyStatusBadge,
    PolicyStatusProgress,
  },
})
export default class PolicyResultsSummaryCard extends Vue {
  @Prop({ type: String, default: 'Gesamt' })
  title!: string;

  @Prop({ type: String, default: 'Bewertung' })
  valueLabel!: string;

  @Prop({
    type: Object,
    default: () => emptyPolicyResults(),
  })
  results!: PolicyResults;

  /** Optional: nur diese Status-Zeilen anzeigen (leer = alle). */
  @Prop({ type: Array, default: () => [] })
  visibleStatuses!: PolicyStatus[];

  /** Prüft, ob eine Status-Zeile in der Tabelle angezeigt werden soll. */
  showStatus(status: PolicyStatus): boolean {
    if (!this.visibleStatuses || this.visibleStatuses.length === 0) {
      return true;
    }
    return this.visibleStatuses.includes(status);
  }
}
